module.exports = "<div *ngIf=\"showConnector\" class=\"schema-connector\">\n    <div class=\"schema-connector-circle\"></div>\n    <div class=\"schema-connector-line\"></div>\n    <div class=\"schema-connector-circle\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projectWizard/schema-connector/schema-connector.component.html
// module id = 1815
// module chunks = 0